import { z } from 'zod';

// src/i18n/locales.ts
var SUPPORTED_LOCALES = [
  { code: "en", displayName: "English", nativeName: "English", dir: "ltr" },
  { code: "es", displayName: "Spanish", nativeName: "Espa\xF1ol", dir: "ltr" },
  { code: "fr", displayName: "French", nativeName: "Fran\xE7ais", dir: "ltr" },
  { code: "de", displayName: "German", nativeName: "Deutsch", dir: "ltr" },
  { code: "ar", displayName: "Arabic", nativeName: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629", dir: "rtl" },
  { code: "he", displayName: "Hebrew", nativeName: "\u05E2\u05D1\u05E8\u05D9\u05EA", dir: "rtl" }
];
var DEFAULT_LOCALE = "en";
var LOCALE_CODES = ["en", "es", "fr", "de", "ar", "he"];
var LocaleCodeSchema = /* @__PURE__ */ z.enum(LOCALE_CODES);
function isSupportedLocale(candidate) {
  return LOCALE_CODES.includes(candidate);
}
function getLocaleDirection(locale) {
  const found = SUPPORTED_LOCALES.find((l) => l.code === locale);
  return found?.dir ?? "ltr";
}
function getLocaleMetadata(locale) {
  return SUPPORTED_LOCALES.find((l) => l.code === locale);
}
function getLocaleNumberingSystem(locale, numerals = "western") {
  const isArabic = locale === "ar" || locale.startsWith("ar-");
  return isArabic && numerals === "eastern" ? "arab" : "latn";
}

export { DEFAULT_LOCALE, LOCALE_CODES, LocaleCodeSchema, SUPPORTED_LOCALES, getLocaleDirection, getLocaleMetadata, getLocaleNumberingSystem, isSupportedLocale };
//# sourceMappingURL=chunk-BTYFPOCZ.js.map
//# sourceMappingURL=chunk-BTYFPOCZ.js.map